import AOS from 'aos'

AOS.init({
  once: true,
  offset: 10,
  disable: 'mobile',
  duration: 400,
  easing: 'ease-out-cubic',
  disable: () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const isMobile = window.matchMedia('(max-width: 767px)').matches
    return prefersReducedMotion || isMobile
  }
})
